import { RT_API_USAGE } from 'src/store/ActionTypes';

/**
 * fetchConfig - Fetch a realtime API config by ID
 * @param payload {string} - config ID
 * @returns {{payload: string, type: string}}
 */
export const fetchConfig = (payload) => ({
  type: RT_API_USAGE.FETCH_CONFIG,
  payload,
});

/**
 * fetchConfigList - Fetch a list of realtime API configs
 * @param payload {string} - querystring for a config list
 * @returns {{payload: string, type: string}}
 */
export const fetchConfigList = (payload) => ({
  type: RT_API_USAGE.FETCH_CONFIG_LIST,
  payload,
});

/**
 * updateFilter - Update view filter
 * @param payload {string} - view filter name
 * @returns {{payload: string, type: string}}
 */
export const updateFilter = (payload) => ({
  type: RT_API_USAGE.UPDATE_FILTER,
  payload,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: RT_API_USAGE.UNSET,
  payload: key,
});

/**
 * resetPage - Reset full page redux state
 * @returns {{type: string}}
 */
export const reset = () => ({
  type: RT_API_USAGE.RESET,
});
